import { useClientPortalAPI } from "@certn/api";
import { Picker } from "@certn/cascadia-react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";

export function TagFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();
  const { clientPortalCaseTags } = useFlags();
  const { data, isLoading } = useClientPortalAPI(
    "/api/internal/client-portal/tags/options/"
  );

  return (
    clientPortalCaseTags && (
      <Picker
        isLoading={isLoading}
        showActionBar
        selectedKeys={params.tag_id?.split(",") || []}
        onSelectionChange={(keys) => setParam("tag_id", Array.from(keys))}
        label={t("Tags")}
        items={data}
        selectionMode="multiple"
        testID="tags-filter"
      />
    )
  );
}
